import { FormProvider } from '@/context/FormProvider';

import {
  type CreateRoleFormValues,
  roleCreateSchema,
  roleUpdateSchema,
  type UpdateRoleFormValues,
} from '@/schemas/role.schema';

import type { Props } from '@/types/formik.type';
import type { Role } from '@/types/role.type';

export const RoleCreateFormProvider = ({
  children,
  onSubmit,
  className,
}: Props<CreateRoleFormValues>) => {
  const initialValues: CreateRoleFormValues = {
    name: '',
    description: '',
    permissions: [],
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={roleCreateSchema}
      className={className}
    >
      {children}
    </FormProvider>
  );
};

export const RoleUpdateFormProvider = ({
  children,
  initialValues,
  onSubmit,
  className,
}: Props<Role>) => {
  const _initialValues: UpdateRoleFormValues = {
    name: initialValues?.name || '',
    description: initialValues?.description || '',
    add_permission_ids: [],
    remove_permission_ids: [],
    hasPermissionsSelected: initialValues?.permissions.length > 0 || false,
  };

  return (
    <FormProvider
      initialValues={_initialValues}
      onSubmit={onSubmit}
      validationSchema={roleUpdateSchema}
      className={className}
      validate={values => {
        const errors: Record<string, string> = {};

        if (!values.hasPermissionsSelected) {
          errors.hasPermissionsSelected = 'At least one permission must be selected';
        }

        return errors;
      }}
    >
      {children}
    </FormProvider>
  );
};
